// Read-only display helpers for workflow flow control. The backend owns the schema
// (docs/pieve/canon/product/global/workflow-authoring-tool-contract-v1.md, "Flow Control (V1)");
// these only project an authored step's flowControl / flow config for rendering.

const SCENARIO_LABELS = {
  onFailure: 'On failure',
  onSuccess: 'On success',
  onNoResults: 'On no results'
};

const FLOW_ACTION_LABELS = {
  stop: 'Stop run',
  ignore: 'Ignore and continue',
  continue: 'Continue loop',
  break: 'Break loop',
  none: 'Do nothing',
  end_run_success: 'End run (success)',
  end_run_failure: 'End run (failure)',
  notify_only: 'Notify only'
};

const asPlainObject = (value) => (value && typeof value === 'object' && !Array.isArray(value) ? value : null);

export const getFlowActionLabel = (action) => {
  const key = String(action || '').toLowerCase();
  return FLOW_ACTION_LABELS[key] || key || '';
};

const summarizeNotify = (notify) => {
  const block = asPlainObject(notify);

  if (!block) {
    return null;
  }

  const channels = [];

  if (block.sendEmail === true) {
    channels.push('email');
  }

  if (block.emitEvent === true) {
    channels.push('event');
  }

  return {
    channels,
    emailTo: block.sendEmail === true ? block.emailTo || null : null,
    eventLevel: block.emitEvent === true ? block.eventLevel || 'info' : null
  };
};

// Projects a step's flow-control config into an ordered list of { key, label, action, notify } rows for display.
export const getStepFlowControlRows = (step) => {
  const type = String(step?.type || '').toLowerCase();

  if (type === 'flow') {
    const options = asPlainObject(step?.options) || {};
    return [
      {
        key: 'flow',
        label: 'Flow',
        action: getFlowActionLabel(options.action),
        notify: summarizeNotify(options.notify)
      }
    ];
  }

  const flowControl = asPlainObject(step?.options?.flowControl);

  if (!flowControl) {
    return [];
  }

  return ['onFailure', 'onSuccess', 'onNoResults']
    .filter((scenario) => asPlainObject(flowControl[scenario]))
    .map((scenario) => {
      const hook = flowControl[scenario];
      return {
        key: scenario,
        label: SCENARIO_LABELS[scenario],
        action: scenario === 'onSuccess' ? null : getFlowActionLabel(hook.action),
        notify: summarizeNotify(hook.notify)
      };
    });
};
